import { connect } from 'react-redux';
import actionCreator from '../../components/redux/action-creator';
import * as rlabSelectors from '../../components/rlab/selectors/rlab-selectors';

import OffersPageComponent from './OffersPageComponent';

/**
 * The campaign and variant whose offer pool is hydrated server-side behind the
 * campaign metric. A loan allocated to it mid-page-load fetched its offers before
 * the metric existed, so those offers have to be reload for hydration to occur.
 *
 * Deliberately declared here rather than reusing the page's CAMPAIGN_CODE: pointing
 * that constant at a future experiment must not silently grant it reload behaviour.
 */
const OFFER_POOL_RELOAD_CAMPAIGN = '2026-05-multiTermComparison';
const OFFER_POOL_RELOAD_VARIANT = 'experiment';

function mapStateToProps(state, props) {
    const { offersPage } = state;

    // Reload is necessary for campaigns that dynamically hydrate offers on the loan object server-side.
    // Allocation is deliberately triggered after the client has seen offers, so the offers already in
    // state were fetched while this loan was still treated as a non-experiment loan. Applies to both
    // the authenticated and unauthenticated pages: a loan whose first allocation happens on the
    // unauthenticated page (e.g. a vendor lead) hits the same ordering.
    const shouldReloadOffers = rlabSelectors.wasNewlyGenerated(state, OFFER_POOL_RELOAD_CAMPAIGN)
        && rlabSelectors.getVariant(state, OFFER_POOL_RELOAD_CAMPAIGN) === OFFER_POOL_RELOAD_VARIANT;
    const {
        cardId,
        clientStateMinAmount = props.clientStateMinAmount,
        customizedOffer,
        fetching,
        getsQLDiscount = props.getsQLDiscount,
        getsRLReturningClientDiscount = props.getsRLReturningClientDiscount,
        hasError,
        isTeamMember = props.isTeamMember,
        getsCyberMondayDiscount = props.getsCyberMondayDiscount,
        autoPayDiscountConfig,
        maxOffer,
        minOffer,
        offers,
        user = props.user,
        requestedAmountAvailable
    } = offersPage;

    return {
        ...props,
        cardId,
        clientStateMinAmount,
        customizedOffer,
        fetching,
        getsQLDiscount,
        getsRLReturningClientDiscount,
        hasError,
        isTeamMember,
        getsCyberMondayDiscount,
        autoPayDiscountConfig,
        maxOffer,
        minOffer,
        offers,
        user,
        requestedAmountAvailable,
        shouldReloadOffers,
    };
}

const mapDispatchToProps = (dispatch, _ownProps) => ({
    fetchOffers: (params) => {
        // Access the current state using dispatch and getState
        dispatch((_, getState) => {
            const state = getState();
            // Check the condition in the state
            if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
                dispatch(actionCreator.fetchOffersAuthenticated(params, state.loan.loanJson.loanId));
            } else if (params && params.token) {
                dispatch(actionCreator.pollWithAppRouterToken(params.token));
            } else {
                dispatch(actionCreator.fetchOffers(params));
            }
        });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OffersPageComponent);